import React from "react" ;
import style from "./AvatarDefault.module.scss" ;
const AvatarDefaultName : React.FC<{ name : string }> = ({ name })=>{
      let _name : string  = name.split(" ").slice(0,2).map((name:string)=>{
            return name[0];
      }).join("").toUpperCase();
      return <div className={style.avatar_name}>{_name}</div>
}
export default AvatarDefaultName ;